import './style.css';
import { SceneManager } from './sceneManager';
// Canvas
var sceneManager = SceneManager.getInstance();
sceneManager.setupScene();
sceneManager.update();
